
import { v4 as uuidv4 } from 'uuid';
import { ResellerPlanDetails } from './resellerPlans/types';

// Function to create a new blank plan (without using any defaults)
export const createNewPlan = (): ResellerPlanDetails => {
  // Generate a random 5-digit plan number
  const planNumber = Math.floor(10000 + Math.random() * 90000).toString();
  
  return {
    id: uuidv4(),
    name: 'New Plan',
    description: 'New reseller plan description',
    planType: 'reseller',
    setupFee: 99,
    annualPrice: 999,
    maxInstances: 3,
    maxManagers: 3,
    maxAdmins: 50,
    maxUsers: 1000,
    recommended: false,
    planNumber,
    features: [
      { name: 'White-labeled instances', included: true },
      { name: 'Custom domain support', included: true },
      { name: 'Email support', included: true }
    ]
  };
};

// Function that returns a default plan if needed (used for clean typechecking)
export const getDefaultResellerPlan = (): ResellerPlanDetails => {
  return createNewPlan();
};
